$(() => {
  $('.js-hide-on-click').click(e => {
    $(e.currentTarget).fadeOut();
  });
});
